/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import React from 'react'
// import {Button as MuiButton} from "@material-ui/core";
// import useStyles from '../Component/Theme_1/FormControlsCss';
import ThemeControls from "../Component/AllThemesControl";
export default function Button(props) {
    const {useStyle} = ThemeControls;
    let {ButtonName,type,id, onClick,field_disabled,color,reltar, icon} = props
    
    const classes = useStyle();

    return ( 
      
        <button type={type} id={id} disabled={field_disabled} icon={icon} reltar={reltar} onClick={onClick} color={color} className={props.className} style={props.ButtonStyle} >{ButtonName}</button>
      
    )
        
        
}
